import { render, staticRenderFns } from "./troubleAplplyOper.vue?vue&type=template&id=9789b98c&scoped=true"
import script from "./troubleAplplyOper.vue?vue&type=script&lang=js"
export * from "./troubleAplplyOper.vue?vue&type=script&lang=js"
import style0 from "./troubleAplplyOper.vue?vue&type=style&index=0&id=9789b98c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9789b98c",
  null
  
)

export default component.exports